import { Paper, Typography } from "@mui/material"
import { PropsWithChildren } from "react";
import Loading from "./Loading";

function Wrapper({ children }: PropsWithChildren<{}>){
    return <Paper sx={{ p: '0.7rem 1rem' }}>{children}</Paper>
}

interface LoadingWrapperProps {
    child: JSX.Element,
    isLoading?: boolean,
    isSucceeded?: boolean,
    notFound?: boolean,
    error?: boolean,
    errorTxt?: string
}

export default function LoadingWrapper({ 
    child, 
    isLoading = true, 
    isSucceeded = false, 
    notFound = false, 
    error = false,
    errorTxt = "Oh no, there was an error"
}: LoadingWrapperProps){
    if(isSucceeded) return (<>{ child }</>);
    else if(isLoading) return <Wrapper children={<Loading data-testid="loading"/>} />
    else if(error) return <Wrapper children={<Typography data-testid="error-res">{errorTxt}</Typography>} />
    else if(notFound) return <Wrapper children={<Typography data-testid="notFound-res">Not found</Typography>}/>
    else return <Wrapper children={<Typography data-testid="notData-res">No data</Typography>} />
}